import React from 'react';


export const Menu = ({ className }) => (
    <svg className={className} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='18' height='2' transform='matrix(1 0 0 -1 3 7)' fill='#FF3200' />
        <rect width='18' height='2' transform='matrix(1 0 0 -1 3 19)' fill='#FF3200' />
        <rect width='18' height='2' transform='matrix(1 0 0 -1 3 13)' fill='#FF3200' />
    </svg>
);
